/**
 * Runtime settings, read from /config.json at start-up so one build serves any deployment.
 * Replace the file next to index.html to point the console at another API or issuer.
 */
export interface ConsoleConfig {
  /** API base, e.g. https://api.example.com */
  apiUrl: string;
  /** OIDC issuer the API trusts; must offer authorisation code + PKCE for a public client */
  issuer: string;
  clientId: string;
  scope: string;
  /** extra authorisation-request parameters some IdPs need, e.g. {"audience": "workcore-api"} */
  authParams?: Record<string, string>;
}

let config: ConsoleConfig | undefined;

export async function loadConfig(): Promise<ConsoleConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`could not load /config.json (HTTP ${res.status})`);
  config = (await res.json()) as ConsoleConfig;
  return config;
}

export function cfg(): ConsoleConfig {
  if (!config) throw new Error("config not loaded");
  return config;
}
